module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_black.3e20a740.png";